'use es6';

import { getAll as getAllProblems } from '../../private/action-problem-solution/actions/set-dashboard-permission/problem';
import { getProblem } from '../../private/action-problem-solution/common/get-problem';
import { isEnabled } from '../../private/action-problem-solution/common/is-enabled';
export const canSetDashboardPermission = params => isEnabled(params, getAllProblems);
export const getSetDashboardPermissionProblem = params => getProblem(params, getAllProblems);